import React from 'react';

import {Helmet} from 'views/module';

import {useParams} from 'views/module';

import ClientViewScene from 'views/scenes/client/detail/ClientView';

const ClientView = (props) => {
  const params = useParams();

  const clientRn = params.clientRn;

  return (
    <>
      <Helmet>
        <title>Quilt: Client Details</title>
      </Helmet>
      <ClientViewScene
        clientRn={clientRn}
      />
    </>
  );
};

export default ClientView;
